import React from 'react';
import useColor, { useContent } from '../../context/themeContext'
import { List, Avatar, ListItem, Link } from '@material-ui/core'
import { SwitchIcon } from '../Profile/helpers'
import Logo from '../../assets/img/to-you-heart.svg';

const Footer = () => {

    const { Content } = useContent()
    const { COLORS } = useColor()

    return (
        <footer>
            <p>
                <a target="_blank" href={"https://toyou.it/"} >
                    <img src={Logo} alt="toyou_logo" />                                  
                </a>
            </p>
            {/* <p style={{color: COLORS.primary}}>
                {Content?.footer?.text}
            </p> */}
            <List className="footer-social">
                {
                    Content?.socials?.map((social) => {
                        return (
                            <ListItem style={{ width: "auto" }}>
                                <Link target="_blank" href={social?.url} color="inherit">
                                    <Avatar>
                                        {SwitchIcon(social?.name)}
                                    </Avatar>
                                </Link>
                            </ListItem>
                        )
                    })
                }
            </List>
        </footer>

    )



}

export default Footer